/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-05-06 10:39:58
 * @FilePath: \jyrg-web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @Author: gongzhichao
 * @Date: 2023-04-13 00:00:00
 * @Description: 项目入口文件
 */
import Vue from "vue";
import api from "./api";
import App from "./App.vue";
import utils from "./utils/index.js";
import store from "./store";
import moment from "moment";
import router from "./router";
import config from "./config";
import ElementUI from "element-ui";

import MetaInfo from "vue-meta-info";
import * as vConsole from "vconsole";

import "./config/useVant.js";
import "./router/permission";
import "./assets/styles/index.css";
import "element-ui/lib/theme-chalk/index.css";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
Vue.config.productionTip = false;

Vue.use(MetaInfo);
Vue.use(ElementUI);

Vue.prototype.$api = api;
Vue.prototype.$utils = utils;
Vue.prototype.$config = config;
Vue.prototype.$moment = moment;
// 封装router，跳转页面打开新窗口(弃用 - 需求方何明明)
Vue.prototype.$Router = function (path, query) {
  let routeInfo = this.$router.resolve({ path, query });
  window.open(routeInfo.href, "_blank");
};

console.info(
  "process.env.NODE_ENV",
  process.env.NODE_ENV,
  config.orderBaseUrl[process.env.NODE_ENV]
);

if (process.env.NODE_ENV !== "production" && utils.isClientType() == "mobile") {
  // eslint-disable-next-line no-new,new-cap
  new vConsole();
}

// new vConsole();

new Vue({
  router,
  store,
  render: (h) => h(App),
  //这里与vue.config.js中的事件名相对应
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
}).$mount("#app");
